import ContactFormController from '@/controllers/ContactFormController';
import { bindRevealButtons } from '@/controllers/ContactRevealController';

/**
 * Wires the `data-action` hooks the views declare.
 *
 * This file used to decode rot13-encoded contact details out of a JSON payload
 * in the layout and fill them into the page — an encoding that stopped a regex
 * over the HTML source and nothing that runs JavaScript. The details no longer
 * appear in any page, encoded or otherwise, so the decoding went with them:
 * the "Vis kontaktinformasjon" buttons fetch them from the reveal endpoint
 * after a bot check instead (see ContactRevealController).
 */

let contactController: ContactFormController | null = null;

function onContactUsClick(event: Event): void {
  event.preventDefault();

  contactController ??= new ContactFormController('#contact-modal');
  contactController.show();
}

export function initBehaviour(): void {
  document.querySelectorAll<HTMLElement>('a[data-action="contactus"]').forEach((element) => {
    element.addEventListener('click', onContactUsClick);
  });

  bindRevealButtons();
}
